import React from "react";
import { Link } from "react-router-dom";
import { AppSettings } from "./../../config/app-settings.js";
import HeaderUser from "./header-user.jsx";
import ThemeModeToggle from "./theme-mode-toggle.jsx";
import { PondStatBrandLogo } from "../sidebar/sidebar-brand.jsx";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.toggleAppHeaderMegaMenuMobile =
      this.toggleAppHeaderMegaMenuMobile.bind(this);
    this.state = { appHeaderMegaMenuMobile: false };
  }

  toggleAppHeaderMegaMenuMobile() {
    this.setState({
      appHeaderMegaMenuMobile: !this.state.appHeaderMegaMenuMobile,
    });
  }

  render() {
    return (
      <AppSettings.Consumer>
        {({
          toggleAppSidebarMobile,
          toggleAppSidebarEnd,
          toggleAppSidebarEndMobile,
          appHeaderInverse,
          appSidebarTwo,
          appSidebarNone,
        }) => (
          <div
            id="header"
            className={
              "app-header " + (appHeaderInverse ? "app-header-inverse" : "")
            }
          >
            <div className="navbar-header">
              {appSidebarTwo && (
                <button
                  type="button"
                  className="navbar-mobile-toggler"
                  onClick={toggleAppSidebarEndMobile}
                >
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                </button>
              )}
              {!appSidebarNone && (
                <button
                  type="button"
                  className="navbar-mobile-toggler"
                  onClick={toggleAppSidebarMobile}
                >
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                </button>
              )}
              <Link to="/dashboard" className="navbar-brand donezo-mobile-brand">
                <PondStatBrandLogo
                  alt="PondStat"
                  className="donezo-brand-logo donezo-brand-logo--compact"
                />
              </Link>
            </div>

            <div className="donezo-header-main">
              <div className="donezo-header-title flex-grow-1 d-none d-md-block">
                <span className="text-muted small fw-semibold text-uppercase">
                  Platform Admin
                </span>
              </div>

              <div className="donezo-header-actions">
                <ThemeModeToggle />
                <HeaderUser />
              </div>
            </div>

            {appSidebarTwo && (
              <div className="navbar-nav">
                <div className="navbar-divider d-none d-md-block"></div>
                <div className="navbar-item d-none d-md-block">
                  <Link
                    to="/"
                    onClick={toggleAppSidebarEnd}
                    className="navbar-link icon"
                  >
                    <i className="fa fa-th"></i>
                  </Link>
                </div>
              </div>
            )}
          </div>
        )}
      </AppSettings.Consumer>
    );
  }
}

export default Header;
